// extracted by mini-css-extract-plugin
export default {"switcher-container":"Juyk","switcherContainer":"Juyk","link":"n5bC","active":"FC08","icon":"yvcU"};